import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "legal_affairs_container" }
const _hoisted_2 = { class: "left_content" }
const _hoisted_3 = {
  key: 0,
  class: "right_content"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "legal@webeye.cn", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("返回上一步")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定发送")

import { ref } from 'vue';
  import dayjs from 'dayjs';
  import { DialogConfig, DialogFormItem } from '@/components/WeDialog/types';
  import { useApp } from '@/hooks/useApp';
  import { required } from '@/utils/validate';
  import { appStore } from '@/store/modules/app';
  import { get_contract_legal_letter_template, send_legal_letter, preview_legal_letter_template } from '@/api/contract';
  import cloneDeep from 'lodash-es/cloneDeep';
  import { useAppInfo } from '@/hooks/useAppInfo';
  import { formatTime } from '@/utils/time';
  import { getValueById, isEmptyData } from '@/utils/common';
  import pickBy from 'lodash-es/pickBy';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    contract: { default: () => ({}) }
  },
  setup(__props: any, { expose }) {

const props = __props as { contract: Recordable }

  

  const { $showDialog, $message } = useApp();
  const { model } = useAppInfo();

  const dialog_visible = ref(false);
  const legal_affairs_model = ref<Recordable>({});
  let preview_legal_affairs = ref<Recordable>({});
  const email_template_items = ref<Recordable[]>([]);

  function find_email_template_name(id) {
    if (!id) {
      return '';
    }
    return email_template_items.value.find((f) => f.id === id)!.scene2;
  }
  // 生成&发送法务函
  function gen_legal_affairs() {
    const company = props.contract.company || { name: '', short_name: '' };
    const we_company = props.contract.we_company || { name: '' };
    const send_to =
      props.contract.person_list.length > 0 ? props.contract.person_list.map((m) => m.email).join(',') : '';
    const current_day = dayjs();
    let overdue_amount = 0;
    props.contract.bill_list.forEach((f) => {
      if (current_day.diff(f.pay_money_deadline) >= 10) {
        overdue_amount += f.finance_to_pay_money;
      }
    });
    const init: Recordable = {
      ...{
        company_name: company.name,
        company_short_name: company.short_name,
        we_company_name: we_company.name,
        contract_date: props.contract.show_begin_time,
        overdue_amount,
        send_to,
      },
      ...legal_affairs_model.value,
    };
    get_contract_legal_letter_template({ contract_id: props.contract.id }).then((res) => {
      email_template_items.value = res.map((m) => ({ id: m.id, name: m.rd_scene2, scene2: m.scene2 }));
      const inputs: DialogFormItem[] = [
        {
          label: '法务函类型',
          result: 'email_template_id',
          type: 'select',
          items: email_template_items.value,
          rules: [required()],
          width: 24,
        },
        {
          label: '签约方',
          result: 'company_name',
          type: 'text',
          rules: [required()],
          width: 24,
        },
        {
          label: '签约方简称',
          result: 'company_short_name',
          type: 'text',
          rules: [required()],
          show: (result) =>
            find_email_template_name(result.email_template_id) === model.value.EmailTemplate.SCENE2['担保'],
          width: 24,
        },
        {
          label: '担保方',
          result: 'guarantee_company_name',
          type: 'text',
          rules: [required()],
          show: (result) =>
            [model.value.EmailTemplate.SCENE2['常规签约（双甲方）'], model.value.EmailTemplate.SCENE2['担保']].includes(
              find_email_template_name(result.email_template_id)
            ),
          width: 24,
        },
        {
          label: '担保方简称',
          result: 'guarantee_company_short_name',
          type: 'text',
          rules: [required()],
          show: (result) =>
            find_email_template_name(result.email_template_id) === model.value.EmailTemplate.SCENE2['担保'],
          width: 24,
        },
        {
          label: '我方主体',
          result: 'we_company_name',
          type: 'text',
          rules: [required()],
          width: 24,
        },
        {
          label: '签约日期',
          result: 'contract_date',
          type: 'date',
          rules: [required()],
          width: 24,
        },
        {
          label: '协议名称',
          result: 'agreement_name',
          type: 'text',
          rules: [required()],
          width: 24,
        },
        {
          label: '发件日期',
          result: 'send_time',
          type: 'date',
          rules: [required()],
          init: dayjs(),
          width: 24,
        },
        {
          label: '付款节点',
          result: 'expected_pay_time',
          type: 'date',
          rules: [required()],
          init: dayjs().add(5, 'day'),
          width: 24,
        },
        {
          label: '欠款金额',
          result: 'overdue_amount',
          type: 'number',
          rules: [required()],
          componentProps: {
            precision: 2,
            step: 0.1,
          },
          width: 24,
        },
        {
          label: '收件人',
          result: 'send_to',
          type: 'text',
          rules: [required()],
          placeholder: '如有多条请以英文逗号分隔',
          width: 24,
        },
        {
          label: '抄送',
          result: 'copy_to',
          type: 'text',
          placeholder: '如有多条请以英文逗号分隔',
          width: 24,
        },
      ];
      const dialog: DialogConfig = {
        title: '生成&发送法务函',
        labelCol: '100px',
        blocks: [
          { type: 'input', value: inputs },
          { label: '附件', result: 'accessory', type: 'backend_oss_upload', width: 24, mode: 'multiple' },
        ],
        okText: '下一步',
        init,
        callback: (result) => {
          result.send_time = formatTime(result.send_time, 'YYYY-MM-DD');
          result.expected_pay_time = formatTime(result.expected_pay_time, 'YYYY-MM-DD');
          legal_affairs_model.value = result;
          get_email_content();
          appStore.SET_WE_DIALOG(null);
          dialog_visible.value = true;
        },
      };
      $showDialog(dialog);
    });
  }
  function get_email_content() {
    const params: Recordable = { ...cloneDeep(legal_affairs_model.value), contract_id: props.contract.id };
    preview_legal_letter_template(params).then((res) => {
      const kk_email = 'eric.tao@webeye.cn';
      const find_kk_index = res.send_to.findIndex((f) => f === kk_email);
      if (find_kk_index !== -1) {
        res.send_to.splice(find_kk_index, 1);
      }
      preview_legal_affairs.value = res;
    });
  }
  function handle_back() {
    dialog_visible.value = false;
    preview_legal_affairs.value = {};
    gen_legal_affairs();
  }
  function handle_send() {
    let params: Recordable = { ...cloneDeep(legal_affairs_model.value), contract_id: props.contract.id };
    params = pickBy(params, (value) => !isEmptyData(value));
    send_legal_letter(params).then(() => {
      $message.success('发送成功');
      dialog_visible.value = false;
      preview_legal_affairs.value = {};
    });
  }

  expose({
    gen_legal_affairs,
  });

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_AForm = _resolveComponent("AForm")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AModal = _resolveComponent("AModal")!

  return (_openBlock(), _createBlock(_component_AModal, {
    visible: dialog_visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialog_visible).value = $event)),
    centered: "",
    closable: false,
    maskClosable: "",
    width: "1200px",
    title: "生成&发送法务函",
    wrapClassName: "we-dialog_container"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: handle_back }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: handle_send
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AForm, { model: legal_affairs_model.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "法务函类型" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(getValueById)(email_template_items.value, legal_affairs_model.value.email_template_id)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "签约方" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.company_name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (
                [_unref(model).EmailTemplate.SCENE2['常规签约（双甲方）'], _unref(model).EmailTemplate.SCENE2['担保']].includes(
                  find_email_template_name(legal_affairs_model.value.email_template_id)
                )
              )
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "担保方" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.guarantee_company_name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                find_email_template_name(legal_affairs_model.value.email_template_id) === _unref(model).EmailTemplate.SCENE2['担保']
              )
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 1,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "签约方简称" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.company_short_name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                find_email_template_name(legal_affairs_model.value.email_template_id) === _unref(model).EmailTemplate.SCENE2['担保']
              )
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 2,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "担保方简称" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.guarantee_company_short_name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "签约日期" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.contract_date), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "协议名称" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.agreement_name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "付款节点" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(formatTime)(legal_affairs_model.value.expected_pay_time, 'YYYY-MM-DD')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "欠款金额" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(legal_affairs_model.value.overdue_amount), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (!_unref(isEmptyData)(_unref(preview_legal_affairs)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "发件人" }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "收件人" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_unref(preview_legal_affairs).send_to.join(',')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "抄送" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_unref(preview_legal_affairs).copy_to.join(',') || '空'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "主题" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_unref(preview_legal_affairs).email_title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "附件" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString((legal_affairs_model.value.accessory || []).map((x) => x.name).join(' ') || '空'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (dialog_visible.value)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "邮件正文" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: _unref(preview_legal_affairs).email_content
                                  }, null, 8, _hoisted_5)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})